(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('geoname-localization', {
            parent: 'entity',
            url: '/geoname-localization',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.geonameLocalization.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/geoname-localization/geoname-localizations.html',
                    controller: 'GeonameLocalizationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('geonameLocalization');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('geoname-localization-detail', {
            parent: 'geoname-localization',
            url: '/geoname-localization/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.geonameLocalization.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/geoname-localization/geoname-localization-detail.html',
                    controller: 'GeonameLocalizationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('geonameLocalization');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GeonameLocalization', function($stateParams, GeonameLocalization) {
                    return GeonameLocalization.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'geoname-localization',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('geoname-localization-detail.edit', {
            parent: 'geoname-localization-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geoname-localization/geoname-localization-dialog.html',
                    controller: 'GeonameLocalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GeonameLocalization', function(GeonameLocalization) {
                            return GeonameLocalization.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('geoname-localization.new', {
            parent: 'geoname-localization',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geoname-localization/geoname-localization-dialog.html',
                    controller: 'GeonameLocalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                geonameId: null,
                                language: null,
                                name: null,
                                isPreferredName: null,
                                isShortName: null,
                                isColloquial: null,
                                isHistoric: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('geoname-localization', null, { reload: 'geoname-localization' });
                }, function() {
                    $state.go('geoname-localization');
                });
            }]
        })
        .state('geoname-localization.edit', {
            parent: 'geoname-localization',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geoname-localization/geoname-localization-dialog.html',
                    controller: 'GeonameLocalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GeonameLocalization', function(GeonameLocalization) {
                            return GeonameLocalization.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('geoname-localization', null, { reload: 'geoname-localization' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('geoname-localization.delete', {
            parent: 'geoname-localization',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geoname-localization/geoname-localization-delete-dialog.html',
                    controller: 'GeonameLocalizationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GeonameLocalization', function(GeonameLocalization) {
                            return GeonameLocalization.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('geoname-localization', null, { reload: 'geoname-localization' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
